import apiClient from "../api/apiClient";

/**
 * Get kategori VA/VE
 */
export const getVaVeCategories = async () => {
  const response = await apiClient.get("/categories");
  return response.data || [];
};

/**
 * Get semua data VA/VE + filter
 */
export const getVaVes = async (params = {}) => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search) queryParams.append("search", params.search);
  if (params.project_id) queryParams.append("project_id", params.project_id);
  if (params.category_id) queryParams.append("category_id", params.category_id);
  if (params.status) queryParams.append("status", params.status);
  if (params.sort_by) queryParams.append("sort_by", params.sort_by);

  const response = await apiClient.get(
    `/vave?${queryParams.toString()}`
  );

  return response.data;
};

/**
 * Detail VA/VE
 */
export const getVaVeById = async (id) => {
  const response = await apiClient.get(`/vave/${id}`);
  return response.data;
};

/**
 * Create VA/VE
 */
export const createVaVe = async (data) => {
  const response = await apiClient.post("/vave", data);
  return response.data;
};

/**
 * Update VA/VE
 */
export const updateVaVe = async (id, data) => {
  const response = await apiClient.put(`/vave/${id}`, data);
  return response.data;
};

/**
 * Delete VA/VE
 */
export const deleteVaVe = async (id) => {
  const response = await apiClient.delete(`/vave/${id}`);
  return response.data;
};
